import { TRoleNames } from './roles';

export const hasRequiredRoles = (
  userRoles: TRoleNames[],
  featureRoles: TRoleNames[] = [],
) => {
  const result = featureRoles.some((frole) => userRoles.includes(frole));

  return result;
};
